import React, { useState, useEffect } from "react";
import "./api.css";


const Api = () => {

  


  return (
    <div className="apiBody">
    <iframe id="inlineFrameExample"
    title="Inline Frame Example"
    width="100%"
    height="100%"
    src="https://api.stats.voicehub.astroline.com:4001/api-docs/v1">
    </iframe>
    </div>
  );
};

export default Api;
